import { walkieTargetKey } from '@itsappy/shared';
import { useWalkie } from '@/store/walkie';
import { Avatar } from '@/components/ui';

/**
 * Who is on the radio right now.
 *
 * A voice arriving from nothing is the one thing a walkie talkie must not do
 * — the sound plays wherever you are in the app, so something on screen has to
 * say whose it is.
 */
export function WalkieHud() {
  const speakers = useWalkie((state) => state.speakers);
  if (!speakers.length) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-3 z-50 flex flex-col items-center gap-2">
      {speakers.map(({ user, target }) => (
        <div
          key={user.id + walkieTargetKey(target)}
          className="flex items-center gap-2 rounded-full bg-surface-2/95 py-1.5 pl-1.5 pr-4 text-sm text-ink shadow-lg ring-1 ring-surface-4 backdrop-blur"
        >
          <Avatar user={user} size="sm" />
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-500 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-500" />
          </span>
          <span>
            <span className="font-semibold">{user.name}</span> is on the radio
          </span>
        </div>
      ))}
    </div>
  );
}
